import {createApp} from 'vue'
import options from './StafetDownloadLinks.options'

const el = '.kb-component--stafet-download-links'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetDownloadLinksDOM)=>{
            const component = createApp(options).use(Store)
            component.mount(StafetDownloadLinksDOM)
        })
    }
}

